import { useMutation } from '@tanstack/react-query';
import { Service } from '@/infra/services/sandbox';
import { message } from 'antd';
import { I18n } from '@aws-amplify/core';

export const useSandboxLogout = () => {
    return useMutation(() => Service.logout(), {
        onError: () => {
            message.error(I18n.get('Error on logout'));
        }
    });
};